import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  model,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { ValidityIconComponent } from '../../../shared/components/validity-icon/validity-icon.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';
import { RestrictedCharactersDirective } from '../../../shared/directives/restricted-characters/restricted-characters.directive';

@Component({
  selector: 'app-form-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => TextInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormControlDirective,
    ReactiveFormsModule,
    RestrictedCharactersDirective,
    ValidityIconComponent,
  ],
  standalone: true,
})
export class TextInputComponent extends BaseFormControlComponent<string> {
  placeholder = model<string>('');
}
